import React, { useState } from "react";
import  "./faceSwapHero.scss";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";

import free from "./../../../../../public/home/hero/free.png";

import faceSwap01 from "@/../public/home/hero/faceSwap01.jpg";
import faceSwap02 from "@/../public/home/hero/faceSwap02.jpg";
import faceSwap03 from "@/../public/home/hero/faceSwap03.jpg";

export default function FaceSwapHero({ setDisplayCard,path }) {
  const router = useRouter();
  const [faceSwapIndex, setFaceSwapIndex] = useState(0);
  const [faceSwapImg, setFaceSwapImg] = useState(faceSwap01);

  const faceSwap = [
    {
      img: faceSwap01,
      name: "single",
    },
    {
      img: faceSwap02,
      name: "group",
    },
    {
      img: faceSwap03,
      name: "video",
    },
  ];

  return (
    <div onClick={() => setDisplayCard("faceswap")} className="faceSwap">
      <div
        onClick={() => router.push(`${path}`)}
        className="imgContainer"
      >
        <Image src={faceSwapImg} alt="face-swap" className="img" />
      </div>
      <div className="faceSwapContent">
        <div className="productTop">
          <div className="titleContainer">
            <p className="title">Face Swap</p>
            <div className="free1">
              {/* <Image src={free} alt="face-swap" /> */}
              <p className="freeTxt1">
                <span className="span span1">F</span>
                <span className="span span2">R</span>
                <span className="span span3">E</span>
                <span className="span span4">E</span>
              </p>
            </div>
          </div>
          {/* <p className={styles.description}>
            Now you can effortlessly transform your videos and photos into
            enchanting master pieces using our incredible filters.
          </p> */}
        </div>
        <div className="bottom">
          <div className="swapImg">
            {faceSwap?.map((item, index) => (
              <div
                className={` ${faceSwapIndex === index ? "active" : ""} imgContainerSwitch `}
                key={index}
              >
                <Image
                  src={item.img}
                  alt={item.name}
                  onClick={() => {
                    setFaceSwapIndex(index);
                    setFaceSwapImg(item.img);
                  }}
                  className="imgSwitch"
                />
              </div>
            ))}
          </div>
          <Link href={`${path}`} className="link">
            <button className="btn1 btn">Try it out</button>
          </Link>
        </div>
      </div>
    </div>
  );
}
